export const hotelSortTypeForConsultation: any = {
  recommended: "プロのおすすめ",
  price: "料金安いホテル",
};
